export default "__VITE_ASSET__aRykLpLE__"